import { merge } from "lodash";

import { LISTING_PRODUCT } from "../../../components/common/const";
import { FIELDS } from "../../../components/common/form/fields";

import common from "./common";

const SPECIAL_SPACE = "　";
export default merge(common, {
  addListingForm: {
    field: {
      maxTip: "Max",
    },
    steps: {
      listingDetails: {
        step: "Listing details",
        title: "Start listing your property",
      },
      location: {
        step: "Location",
        title: "Where is your property?",
      },
      locationV2: {
        step: "Location",
        title: "Where is your property?",
      },
      propertyDetails: {
        step: "Property details",
        title: "Give details about your property",
      },
      propertyDetailsV2: {
        step: "Property details",
        title: "Give details about your property",
      },
      descriptionAndMedia: {
        step: "Description & Media",
        title: "What is your property like?",
      },
      upgradeAndReview: {
        step: "Upgrade & Publish",
        title: "Upgrade & Publish",
        modal: {
          title: "Are you sure you want to publish?",
          content:
            "Go {listingProductName} will require <strong>{credits} {isCreditFlattening, select, true {Ad} other {Featured}} credit{credits, plural, =0 {} =1 {} other{s}}</strong> and publish will consume <strong>{listing} {isCreditFlattening, select, true {Ad} other {Listing}} credit{listing, plural, =0 {} =1 {} other{s}}</strong>.",
          contentWithAutoUpgrade:
            "Go {listingProductName} will require <strong>{credits} {isCreditFlattening, select, true {Ad} other {Featured}} credit{credits, plural, =0 {} =1 {} other{s}}</strong> and will be renewed every {productDuration}th day until cancel. The next upgrade renewal is on {nextUpgradeDate}. Publishing this listing will consume <strong>{listing} {isCreditFlattening, select, true {Ad} other {Listing}} credit{listing, plural, =0 {} =1 {} other{s}}</strong>.",
          contentWithStandardCrossListing:
            "Publishing this listing will consume <strong>{listing} {isCreditFlattening, select, true {Ad} other {Listing}} credit{listing, plural, =0 {} =1 {} other{s}}</strong>. <br/><br/><strong>{adCredit} Ad credit{adCredit, plural, =0 {} =1 {} other{s}}</strong> will be deducted from your PropertyGuru AgentNet account.",
          contentWithCrossListing:
            "Go {listingProductName} will require <strong>{credits} {isCreditFlattening, select, true {Ad} other {Featured}} credit{credits, plural, =0 {} =1 {} other{s}}</strong> and publish will consume <strong>{listing} {isCreditFlattening, select, true {Ad} other {Listing}} credit{listing, plural, =0 {} =1 {} other{s}}</strong>. <br/><br/><strong>{adCredit} Ad credit{adCredit, plural, =0 {} =1 {} other{s}}</strong> will be deducted from your PropertyGuru AgentNet account.",
          contentWithCrossListingAndAutoUpgrade:
            "Go {listingProductName} will require <strong>{credits} {isCreditFlattening, select, true {Ad} other {Featured}} credit{credits, plural, =0 {} =1 {} other{s}}</strong> and will be renewed every {productDuration}th day until cancel. The next upgrade renewal is on {nextUpgradeDate}. Publishing this listing will consume <strong>{listing} {isCreditFlattening, select, true {Ad} other {Listing}} credit{listing, plural, =0 {} =1 {} other{s}}</strong>.<br/><br/><strong>{adCredit} Ad credit{adCredit, plural, =0 {} =1 {} other{s}}</strong> will be deducted from your PropertyGuru AgentNet account.",
          contentWithStandardCrossListingV2:
            "Publishing this listing will consume <strong>{listing} {isCreditFlattening, select, true {Ad} other {Listing}} credit{listing, plural, =0 {} =1 {} other{s}}</strong>. <br/><br/><strong>1 - 10 Ad credits</strong> will be deducted. Please refer to your PropertyGuru AgentNet account for the actual deduction on your listing.",
          contentWithCrossListingV2:
            "Go {listingProductName} will require <strong>{credits} {isCreditFlattening, select, true {Ad} other {Featured}} credit{credits, plural, =0 {} =1 {} other{s}}</strong> and publish will consume <strong>{listing} {isCreditFlattening, select, true {Ad} other {Listing}} credit{listing, plural, =0 {} =1 {} other{s}}</strong>. <br/><br/><strong>1 - 10 Ad credits</strong> will be deducted. Please refer to your PropertyGuru AgentNet account for the actual deduction on your listing.",
          contentWithCrossListingAndAutoUpgradeV2:
            "Go {listingProductName} will require <strong>{credits} {isCreditFlattening, select, true {Ad} other {Featured}} credit{credits, plural, =0 {} =1 {} other{s}}</strong> and will be renewed every {productDuration}th day until cancel. The next upgrade renewal is on {nextUpgradeDate}. Publishing this listing will consume <strong>{listing} {isCreditFlattening, select, true {Ad} other {Listing}} credit{listing, plural, =0 {} =1 {} other{s}}</strong>.<br/><br/><strong>1 - 10 Ad credits</strong> will be deducted. Please refer to your PropertyGuru AgentNet account for the actual deduction on your listing.",
          cancel: "Cancel",
          confirm: "Confirm",
        },
      },
    },
    mobileStepMark: "Step {currentStep} of {allSteps}",
    mobileReview: "Review steps",
    button: {
      back: "Back",
      cancel: "Cancel",
      saveDraft: "Save draft and exit",
      saveAndExit: "Save and exit",
      saveDraftOfMobile: "Save draft and exit",
      saveContinue: "Save and continue",
      save: "Save changes",
      reactivate: "Reactivate",
      backToOverview: "Back to overview",
      backToListings: "Back to my listings",
      publish: "Publish",
      continue: "Continue",
    },
    step2: {
      fields: {
        area: {
          label: "State",
        },
        district: {
          label: "City",
          message: {
            notFound: "The name is not a valid city",
          },
          placeholder: "Search for city name",
          popupPlaceholder: "Please enter a city name",
        },
      },
    },
    stepOfLocation: {
      title: "Location",
      v2: {
        title: "Listing location",
        searchOptions: {
          title: {
            level1: "State",
            level2: "Location",
            level3: "Township",
            level5: "Building / Development",
          },
        },
      },
      [FIELDS.categoryType]: {
        label: "Category type",
      },
      [FIELDS.propertyType]: {
        label: "Property type",
        v2: {
          placeholder: "Select property type",
        },
        v3: {
          label: "Property subtype",
          placeholder: "Select property subtype",
        },
      },
      [FIELDS.buildingName]: {
        label: "Building name",
        placeholder: "Enter your building name",
        message: {
          notFound: "The name is not a valid building name",
          required: "Please enter a building name",
        },
        v2: {
          label: "Project",
          placeholder: "Select project",
        },
      },
      [FIELDS.commercialLot]: {
        label: "Commercial lot",
        placeholder: "eg. Sierra Zentro",
      },
      [FIELDS.state]: {
        label: "State",
        v2: {
          placeholder: "Select state",
        },
      },
      [FIELDS.city]: {
        label: "City",
        placeholder: "eg. Cheras",
        message: {
          notFound: "The name is not a valid city",
        },
        v2: {
          placeholder: "Select city",
        },
      },
      [FIELDS.township]: {
        label: "Township",
        placeholder: "eg. Cyberjaya",
        v2: {
          placeholder: "Select township",
          help: "Choose ‘Other’ if you can't find township",
          tooltip:
            "If you choose 'Other', please input the specific township name. Avoid repeating the location or adding terms like 'sale', 'freehold', etc.",
        },
      },
      [FIELDS.hasNoTownship]: {
        label: "My listing is not in any township.",
      },
      [FIELDS.postCode]: {
        label: "Postcode",
        placeholder: "eg. 12345",
        message: {
          max: "Must be a 5 digit number is allowed.",
          format: "Please enter valid postcode.",
        },
        v2: {
          placeholder: "Enter postcode",
        },
      },
      [FIELDS.address]: {
        label: "Address",
        placeholder: "eg. Jalan Kuching",
        v2: {
          label: "Street",
          placeholder: "Enter street",
        },
      },
      [FIELDS.block]: {
        label: "Block",
        placeholder: "eg. 12345",
      },
      [FIELDS.unit]: {
        label: "Unit/House no.",
        placeholder: "eg. 20",
      },
      [FIELDS.floor]: {
        label: "Floor",
        placeholder: "eg. 20",
      },
      [FIELDS.storey]: {
        label: "Storey",
        v2: {
          placeholder: "Select storey",
        },
      },
      [FIELDS.hiddenAddress]: {
        label: "Hidden address",
      },
      [FIELDS.isHideUnitAndFloorForIProperty]: {
        text: {
          base: "Hide the Block, Unit/House no. and Floor details on iproperty.com.my when published.",
          single:
            "Hide the Unit/House no. detail on iproperty.com.my when published.",
        },
      },
      [FIELDS.propertyGroupType]: {
        label: "Category type",
      },
      map: {
        label: "Property location",
        message: {
          invalid: "No location details have been entered",
          apiError: "Oops! Some error happened with the google map!",
        },
        description:
          'If the details on the map are incorrect, please contact our Customer Service Team via <a href="https://{whatsappPrefix}.whatsapp.com/send?phone=60179439107" target="_blank">+6017 943 9107</a> (WhatsApp), <a href="tel:+60364195188">+603 6419 5188</a> (call hotline) or <a href="mailto:customercare@iproperty.com.my">customercare@iproperty.com.my</a>.',
        v2: {
          description:
            'If the details on the map are incorrect, please contact our Customer Service Team via <a href="mailto:customercare@iproperty.com.my">customercare@iproperty.com.my</a>, <a href="https://{whatsappPrefix}.whatsapp.com/send?phone=60179439107" target="_blank">+6017 943 9107</a> (WhatsApp) or <a href="tel:+60364195188">+603 6419 5188</a> (call hotline).',
        },
      },
      notFound: {
        text: "We couldn’t find this building. Would you like to add this building?",
        button: {
          add: "Add building name",
        },
      },
      addBuilding: {
        title: "Add building",
        buildingName: { label: "Building name" },
        state: {
          label: "State",
        },
        city: {
          label: "City",
          placeholder: "eg. Cheras",
          message: {
            notFound: "The name is not a valid city",
          },
        },
        address: {
          label: "Address",
          placeholder: "eg. Jalan Kuching",
        },
        tips: "All requests will take one (1) business day to process. You will not be able to list your property until your request has been approved.",
        message: {
          success:
            "This building has been successfully request, will take one (1) business day to be processed",
          error: "Request error",
        },
        successfulModel: {
          title: "Request submitted!",
          paragraphOne:
            "The details will be reviewed prior to approval within 1 working day.",
          paragraphTwo:
            "Once approved, you will be informed via email to create your listing.",
        },
        button: {
          change: "Change",
          confirm: "Submit",
          cancel: "Cancel",
        },
      },
      notMatchProperty: {
        title: "Do you want to change the property type?",
        content:
          "The building you selected does not match the property type selected in previous step. Would you like to proceed and auto update your property type ?",
        ok: "Yes, proceed",
        cancel: "Cancel",
      },
    },
    stepOfListingType: {
      title: "Listing details",
      channel: {
        label: "Listing type",
      },
      categoryType: {
        label: "Category type",
      },
      exclusivity: {
        label: "Listing exclusivity",
      },
      storey: {
        label: "Storey",
        placeholder: "Please Select",
      },
      propertyType: {
        label: "Property type",
        placeholder: "Please select",
      },
      auction: {
        label: "",
        checkboxText: "This property will be going to auction",
        field: "Auction",
      },
      auctionDate: {
        label: "Auction date",
        placeholder: "Choose a date",
      },
      coAgency: {
        label: "",
        checkboxText: "This is a co-agency listing",
        field: "Co-Agency",
      },
      referenceNum: {
        label: "Listing reference number",
        placeholder: "eg. 12345",
        tip: "The listing reference number will not be visible on iproperty.com.my.",
      },
      modal: {
        changeChannel: {
          content:
            "As you have changed the listing type, you need to update price information in Step 3: Property Details. ",
          button: {
            confirm: "OK",
          },
        },
        changePropertyType: {
          title: "Do you want to change the property type?",
          content:
            "All the information you have entered for this property will be cleared. Do you still want to proceed?",
          button: {
            cancel: "Cancel",
            confirm: "Yes, proceed",
          },
        },
      },
    },
    stepOfPropertyDetails: {
      fieldset: {
        main: "Property details",
        listingType: "Listing type",
        propertyPrice: "Property price",
        tenure: "Tenure, Title and Occupancy",
        additional: "Additional details",
        features: "Property highlights and features",
        building: "Building facilities",
        unitDetails: "Unit details",
        v3: {
          tenure: "Tenure and Title",
          features: "Unit features",
        },
      },
      more: {
        show: "View more options",
        hide: "Hide more options",
      },
      placeholder: {
        select: "Select one",
      },
      [FIELDS.salePrice]: {
        label: "Sale price ({priceUnit})",
        field: "Sale price",
        placeholder: "Enter sale price",
        warnings: {
          length: "A maximum of 15 digit number is allowed",
          format: "Please enter valid sale price",
          min: "Please enter minimum 5 digits sale price",
          minValue: "Price must be at least RM {min}",
        },
        title: "Sale price per measurement unit",
        built: "Built-up per {areaUnit}: <span>{unit} {price}</span>",
        land: "Gross/Land per {areaUnit}: <span>{unit} {price}</span>",
      },
      [FIELDS.rentPrice]: {
        label: "Rental price ({priceUnit})",
        field: "Rental price",
        placeholder: "Enter rent price",
        warnings: {
          length: "A maximum of 15 digit number is allowed",
          format: "Please enter valid rent price",
          min: "Price must be at least RM 100",
          minValue: "Price must be at least RM {min}",
        },
        title: "Rent price per measurement unit",
        built: "Built-up per {areaUnit}: <span>{unit} {price}</span>",
        land: "Gross/Land per {areaUnit}: <span>{unit} {price}</span>",
      },
      [FIELDS.maintenancePrice]: {
        label: "Monthly maintenance fee ({priceUnit})",
        field: "Monthly maintenance fee",
        placeholder: "eg. 2,000",
        warnings: {
          length: "A maximum of 15 digit number is allowed",
          format: "Please enter valid monthly maintenance fee",
        },
      },
      [FIELDS.grossMeasurementUnits]: {
        label: "Land area unit",
      },
      [FIELDS.builtArea]: {
        label: "Built-up area ({areaUnit})",
        field: "Built-up area",
        placeholder: "eg. 1,200",
        warnings: {
          length: "A maximum of 9 digit number is allowed",
          format: "Please enter valid built-up area",
          minPsf: "Price per sqf must be at least RM {min}",
        },
      },
      [FIELDS.builtAreaLength]: {
        label: SPECIAL_SPACE,
        placeholder: "eg. 120",
        warnings: {
          required: "Please enter a built-up area length",
          length: "A maximum of 9 digit number is allowed for length",
        },
      },
      [FIELDS.builtAreaWidth]: {
        label: "Dimensions",
        placeholder: "eg. 90",
        warnings: {
          required: "Please enter a built-up area width",
          length: "A maximum of 9 digit number is allowed for width",
        },
      },
      [FIELDS.landArea]: {
        label: "Land area ({areaUnit})",
        field: "Land area",
        placeholder: "eg. 1,200",
        acresPlaceholder: "eg. 1.56",
        warnings: {
          length: "A maximum of 9 digit number is allowed",
          format: "Please enter valid land area",
          minValue: "Land area must be at least {min} sqft",
        },
      },
      [FIELDS.landAreaLength]: {
        label: SPECIAL_SPACE,
        placeholder: "eg. 120",
        warnings: {
          required: "Please enter a land area length",
          length: "A maximum of 9 digit number is allowed for length",
        },
      },
      [FIELDS.landAreaWidth]: {
        label: "Dimensions",
        placeholder: "eg. 90",
        warnings: {
          required: "Please enter a land area width",
          length: "A maximum of 9 digit number is allowed for width",
        },
      },
      [FIELDS.legacyLandArea]: {
        label: "Legacy Area Land",
      },
      [FIELDS.unitType]: {
        label: "Unit type",
        v3: {
          label: "Property unit type",
        },
      },
      [FIELDS.orientation]: {
        label: "Direction",
      },
      [FIELDS.furnishing]: {
        label: "Condition",
        v3: {
          label: "Furnishing",
        },
      },
      [FIELDS.bedrooms]: {
        label: "Bedrooms",
        showMore: "Show more bedrooms",
        hideMore: "Hide more bedrooms",
        input: {
          label: "Add bedrooms if more than {max}",
          placeholder: "eg. 10",
        },
        warnings: {
          length: "A maximum of 2 digit number is allowed",
          format: "Please enter valid bedrooms",
        },
        v2: {
          showMore: "Show bedrooms",
          hideMore: "Hide bedrooms",
        },
      },
      [FIELDS.storageRooms]: {
        label: "Maid rooms or store rooms",
        placeholder: "eg. 3",
        warnings: {
          length: "A maximum of 2 digit number is allowed",
          format: "Please enter valid maid rooms or store rooms",
        },
      },
      [FIELDS.bathrooms]: {
        label: "Bathrooms",
        showMore: "Show more bathrooms",
        hideMore: "Hide more bathrooms",
        input: {
          label: "Add bathrooms if more than {max}",
          placeholder: "eg. 8",
        },
        warnings: {
          length: "A maximum of 2 digit number is allowed.",
          format: "Please enter valid bathrooms",
        },
        v2: {
          showMore: "Show bathrooms",
          hideMore: "Hide bathrooms",
        },
      },
      [FIELDS.carpark]: {
        label: "Carparks",
        showMore: "Show more carparks",
        hideMore: "Hide more carparks",
        input: {
          label: "Add carparks if more than {max}",
          placeholder: "eg. 8",
        },
        warnings: {
          length: "A maximum of 2 digit number is allowed.",
        },
        v2: {
          showMore: "Show carparks",
          hideMore: "Hide carparks",
        },
      },
      [FIELDS.tenure]: {
        label: "Tenure",
      },
      [FIELDS.unexpiredYear]: {
        label: "Unexpired lease year",
        placeholder: "eg. 99",
        warnings: {
          length: "A maximum of 3 digit number is allowed.",
          min: "A minimum of 2 digit number is allowed.",
          format: "Please enter valid unexpired lease year",
        },
        v3: {
          label: "Lease year remaining",
          placeholder: "Enter number of lease year remaining",
        },
      },
      [FIELDS.titleType]: {
        label: "Title type",
      },
      [FIELDS.landTitleType]: {
        label: "Land title type",
      },
      [FIELDS.occupancyStatus]: {
        label: "Occupancy status",
      },
      [FIELDS.isBumiLot]: {
        label: "Is this Bumi Lot?",
        options: {
          false: "Non-bumi Lot",
          true: "Bumi Lot",
          null: "Don’t Specify",
        },
      },
      [FIELDS.availabilityDate]: {
        label: "Availability date",
        placeholder: "Select date",
      },
      [FIELDS.isCoAgency]: {
        checkboxText: "This is co-agency listing",
      },
      [FIELDS.isAuction]: {
        checkboxText: "This property will be going to auction",
      },
      [FIELDS.referenceNo]: {
        label: "Listing reference number",
        placeholder: "eg. 294723",
        hints:
          "The listing reference number not be visible on iProperty.com.my.",
      },
      auctionDate: {
        label: "Auction date",
        placeholder: "Choose a date",
      },
    },
    media: {
      requirements: {
        rules: {
          rule0:
            "Cover photo supplied as landscape with a minimum resolution of 800 x 600px",
          rule1: "Maximum file size is 20MB",
          rule2: "Accepted file formats are JPEG, PNG, HEIC",
          rule3: "No duplicate or Illicit/unlawful photos",
          rule4: "No phone numbers or email addresses on photos",
          rule5: "",
        },
        note: {
          title: "<strong>Please note: </strong>",
          imageRule: "To advertise on Premium requires minimum of 5 photos.",
          watermarkRule:
            "The watermark will not be visible here on iProperty PRO, but will be visible on iproperty.com.my once it's published.",
        },
      },
    },
    stepOfDescriptionAndMedia: {
      title: "What is your property like?",
      description: {
        name: "Description",
        tip: "Add a unique description in your chosen language. HTML or emojis are not supported and will be automatically removed. ",
        requirements: {
          description:
            "To meet this quality step you must add a minimum number of characters for description. Please refer to the various minimums for each of the languages.",
          note: "Note: The maximum character limit for the listing description is also mentioned below each field.",
        },
        groupTitle: {
          en_GB: "In English",
          ms_MY: "In Bahasa Malaysia",
        },
        placeholder: {
          en_GB:
            "Describe the property layout, the rooms, what is nearby to the building… etc.",
          ms_MY:
            "Describe the property layout, the rooms, what is nearby to the building… etc.",
        },
      },
      media: {
        name: "Media",
        [FIELDS.images]: {
          label: "Photos",
          subLabel: "Max {max} photos",
          addButton: "Add photos",
          selectPhotos: "Select photos",
          selectAll: "Select All",
          cancel: "Cancel",
          confirmDelete: "Confirm Delete",
        },
        [FIELDS.floorplans]: {
          label: "Floor plans",
          subLabel: "Max {max} floor plans",
          addButton: "Add a floor plan",
        },
        [FIELDS.photo360s]: {
          label: "360 images",
          subLabel: "Max {max} images",
          addButton: "Add 360 images",
          description: "It’s ideal to upload one image per room.",
          imageErrorDescription:
            "Please check your images to ensure they follow the requirements below:",
          tooltip: {
            title: "Requirements for 360 images:",
            rules: [
              "Less than 20MB file size",
              "Preferred dimension: 4096px x 2048px",
              "Equirectangular or single stitched image of 360 degree view",
              "JPEG, PNG or HEIC format",
              "No watermark or trade mark on the image",
            ],
          },
        },
        [FIELDS.video]: {
          label: "YouTube video",
          subLabel: "Add the YouTube video of the property",
          placeholder: "Please enter youtube URL",
        },
        [FIELDS.isLiveTourAvailable]: {
          label: "Availability for Live Tour",
          options: {
            true: "Yes, I’m available for live viewing via video call",
            false: "No, I’m not available",
          },
        },
        [FIELDS.title_gb]: {
          label: "Headline",
          subLabel: "Add a unique headline of the property",
          placeholder: "Write here",
          validation: {
            required: "Please insert a Headline, it's a mandatory field.",
            minLength:
              "Please create a Headline that has 10 characters or more.",
            maxLength: "The headline may not be greater than 70 characters.",
            invalidCharacters:
              "Listing headlines may only contain letters, numbers, and basic punctuation.",
            firstLetterNotCapitalized:
              "The first word in each sentence must begin with a capital letter.",
            hasPhone:
              "A phone number has been detected, please replace it with text.",
            manyPunctuation:
              "Please keep to a maximum of 2 punctuation marks consecutively.",
            invalidCapitalized:
              "Except standard abbreviations like 'MRT' and 'LRT', please only have the first letter of words be capitalized.",
          },
        },
      },
      library: {
        button: {
          showLibrary: "Add photo from building library",
          clear: "Clear all",
          addImage: "Add photos",
        },
        title: "Select photos from our library",
        description:
          "Use a range of photos that best represents your property and the facilities people will have access to.",
        auctionImage: "AUCTION IMAGE",
        tip: "{selectCount} photos selected",
        emptyDescription: "No photos in library for this building",
      },
      modal: {
        photoValidation: {
          title: "Publishing in Premium?",
          content: "You will need to have at least 5 photos.",
          button: { confirm: "Got it" },
        },
      },
    },
    quality: {
      message: {
        description: "Add a description to meet this quality step.",
      },
    },
    stepOfUpgradeAndReview: {
      edit: {
        tip: "Your current tier",
        upgraded: "Upgraded on:",
        expires: "Expires in:",
        rotation: "Next rotation:",
      },
      active: "Current listing upgrade",
      duration: {
        title: "Duration",
        tab: "{duration} days",
        label: `{tierType, plural, =${LISTING_PRODUCT.standard} {90 days} other {+ 90 days Standard}}`,
      },
      listingDurationChangeTooltip: {
        text: "We've updated our listing duration from 90 days to 60 days to better align and streamline the experience across both of our brands.",
        okButton: "Got it",
      },
      amount: {
        label: `{count} {isCreditFlattening, select, true {Ad} other {Featured}} credit{count, plural, =0 {} =1 {} other{s}}`,
      },
      noRemainingTip: {
        single: "Not enough credits for this upgrade. Contact us to top up.",
        standard:
          "Insufficient {isCreditFlattening, select, true {Ad} other {Listing}} credit. Contact us to top up.",
      },
      degradedTip:
        "This listing has been flagged. Please contact your Account Manager to find out more.",
      highestUpgrade: "HIGHEST UPGRADE",
      autoUpgrade: {
        label: "Auto-upgrade",
        tooltip:
          "Auto-upgrade will help you to upgrade your listing tier automatically after it expires. You can cancel at any time.",
        createListingTooltip: {
          title: " Auto-upgrade is switched on for you",
          content: "Upgrade your tier automatically or you can switch it off.",
          okButton: "Got it",
        },
      },
      plusInfo: {
        label: "Add Premium Plus*",
        description:
          "+ {cost} {isCreditFlattening, select, true {Ad} other {Featured}} credit{cost, plural, =0 {} =1 {} other{s}}",
      },
      note: "<strong>*Premium Plus</strong> targets relevant buyers on websites outside of iproperty.com.my.",
      tab: {
        rent: "RENT",
        sale: "BUY",
      },
      button: {
        [LISTING_PRODUCT.premiumPlus]: "Go Premium",
        [LISTING_PRODUCT.premium]: "Go Premium",
        [LISTING_PRODUCT.featured]: "Go Featured",
        [LISTING_PRODUCT.standard]: "Go Standard",
      },
      formatError: {
        title: "You only have 1 {upgrade} to use.",
        message: "Please review your selection before proceeding.",
      },
      totalDeductions: {
        title: "Total deductions",
        useInfo:
          "{credits} {isCreditFlattening, select, true {Ad} other {Featured}} credit{credits, plural, =0 {} =1 {} other{s}}, {listing} Listing{listing, plural, =0 {} =1 {} other{s}}",
        remaining:
          'Balance: <span class="remaining-value">{credits}</span> {isCreditFlattening, select, true {Ad} other {Featured}} credit{credits, plural, =0 {} =1 {} other{s}}, <span class="remaining-value">{listing}</span> {isCreditFlattening, select, true {Ad} other {Listing}}{listing, plural, =0 {} =1 {} other{s}}',
      },
      requiredError: {
        title: "You still need to make a selection for rent.",
        message:
          "Please select the rent tab and choose an upgrade or standard listing to continue.",
      },
      permissionError: {
        title: "Sorry but you are unable to see the details on this step.",
        message:
          "You may not have permission, or the listing ID you're looking for may be wrong incorrect.",
      },
      summary: {
        title: "",
        price: "Price: ",
        builtArea: "Built-up area: ",
        landArea: "Land area: ",
      },
      disclaimer: {
        description:
          "Please note listings are subject to review post submission in accordance with our ",
        link: "Acceptable Use Policy.",
      },
      minImageTip: {
        linkText: "Upload 5 photos minimum",
        restText: " to enable this upgrade.",
      },
      modal: {
        title: "Your upgrade selection will not be saved if you exit.",
        content: "Continue to publish to use your selected upgrade.",
        buttons: {
          confirm: "Continue to publish",
          cancel: "Save and exit",
        },
        confirmation: {
          content:
            "The selected contract does not apply to the secondary agent selected in step 1. Proceed to remove secondary agent or cancel to select another contract.",
          button: {
            cancel: "Cancel",
            confirm: "Yes, proceed",
          },
        },
      },
      dataHook: {
        avgImpressions: "Avg. Impressions",
        moreThanStandard: " {multiplier}x more than Standard",
        mostLikelySRP: "Most likely Search Result Page: ",
        page: "Page {pageNumber}",
        avgImpressionWithDate: ": Based on ({startDate} - {endDate}) in {city}",
        disclaimer: {
          head: "Most likely SRP",
          content: ": Based on {datetime} in {city}",
        },
        listingPosition: {
          notListed: "This listing is not listed",
          above100: "This listing is located on page 100 or more",
          locatedAtPage: "This listing is located on page {pageNumber}",
        },
      },
      geoRedemption: {
        tooltip:
          "The rate may change every week based on market supply and demand trend. When the rate becomes higher, you are likely to receive more leads as many people are searching for properties in that area. Upgrade your listing now!",
      },
      discount: {
        label: "{percentage}% discount",
      },
    },
    previewListing: {
      title: "Preview mode",
      edit: "Return to edit",
    },
    crossListingSurvey: {
      title: "Publish on <strong>PropertyGuru AgentNet</strong>",
      variant1Checked:
        "Enjoy up to <strong>2X more views</strong> per listing by listing on both platforms.",
      variant1Unchecked:
        "By unchecking, you miss out on potential enquiries from the other platform.",
      modal: {
        title: "Publish your listing on PropertyGuru AgentNet",
        content:
          "Thank you for participating in our product development test. Your input enables us to develop relevant product for you.",
      },
    },
    crossListingPublish: {
      title: "Publish on <strong>PropertyGuru AgentNet</strong>",
      checkedDescription:
        "Enjoy up to <strong>2X more views</strong> per listing by listing on both platforms.",
      uncheckedDescription:
        "By unchecking, you miss out on potential enquiries from the other platform.",
      creditIntroduction: {
        lg: "Total credit(s) deduction on PropertyGuru AgentNet",
        sm: "Total deduction",
      },
      adCredit: "{adCredit} Ad credit{adCredit, plural, =0 {} =1 {} other{s}}",
      tooltip: {
        title: "Cross-listing",
        content:
          "<a href='https://www.iproperty.com.my/customer-solutions/agent/products/cross-listing/' target='_blank'>Cross-listing</a> is now enabled by default to help you generate more leads. You can disable it anytime by unchecking the box.",
        button: {
          text: "Got It",
        },
      },
    },
    versionToggle: {
      popover: {
        text: "Starting 16/01/2026, all new listings will be created on the new experience. The option to switch back will no longer be available.",
        button: {
          text: "Got it",
        },
      },
    },
  },
});
